import { Button } from "@heroui/react";
import { MoveLeft } from "lucide-react";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const DocsPageLayout = ({ children }) => {
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const timeoutId = setTimeout(() => {
        const id = location.hash.replace("#", "");
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300);

      return () => clearTimeout(timeoutId);
    }
  }, [location.hash, location.pathname]);

  return (
    <div className="flex flex-col gap-3">
      <Button variant="ghost" className={"text-glass-foreground"} size="sm" onPress={() => navigate("/docs")}>
        <MoveLeft />
        Back
      </Button>

      <div>{children}</div>
    </div>
  );
};

export default DocsPageLayout;
